﻿import window from 'window';
import document from 'document';
import { debounce } from '../../utilities/debounce';
import { getOffset } from '../../utilities/offset';

export const stepIndicator = () => {
    const selectors = {
        root: '.step-indicator',
        scrollableArea: '.step-indicator__step-wrap',
        activeStep: '.step--active'
    };

    let cachedwidth = document.body.clientWidth;

    const config = {
        smallScreen: 767 // breakpoint matches that in _break-points.scss file
    };

    const _findActiveStepScrollPosition = function (root) {
        return getOffset(root.querySelector(selectors.activeStep));
    };

    const _hScrollToStep = function (scrollValue) {
        if (scrollValue) {
            document.querySelector(selectors.scrollableArea)
            .scroll({
                left: scrollValue.left - (window.screen.width / 2) - 16 + 60,
                behavior: 'smooth'
            })
        }
    };

    const windowEvent = debounce(function (e) {           
        var windowWidth = document.body.clientWidth;
        const root = document.querySelector(selectors.root);
        // e.type conditionals added as android and iOS fire resize on scroll
        if (e.type === 'resize' && windowWidth < config.smallScreen && windowWidth != cachedwidth) {                
            cachedwidth = windowWidth; // update the cached width
            _hScrollToStep(
                _findActiveStepScrollPosition(root)
                );
        } 
        if (e.type === 'load' && windowWidth < config.smallScreen) {  
            _hScrollToStep(
                _findActiveStepScrollPosition(root)
                );
        }
    }, 100);

    const _bindEvents = function () {
        window.addEventListener('resize', windowEvent);
        window.addEventListener('load', windowEvent);
    };

    const init = function () {
        const root = document.querySelectorAll(selectors.root);
        if (root.length) {
            _bindEvents();
        }
    };

    return {
        init: init
    };
};
